import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarDismiss } from '@angular/material/snack-bar';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SnackBarService {

  constructor(
    private readonly sb: MatSnackBar
  ) {}

  public error(message: string, duration: number = 3000): Observable<MatSnackBarDismiss> {
    const snackRef = this.sb.open(message, 'Ok', { horizontalPosition: 'center', verticalPosition: 'top', duration });

    return snackRef.afterDismissed();
  }

  public info(message: string, duration: number = 3000): Observable<MatSnackBarDismiss> {
    const snackRef = this.sb.open(message, 'Ok', { horizontalPosition: 'center', verticalPosition: 'top', duration });

    return snackRef.afterDismissed();
  }
}
